document.addEventListener('DOMContentLoaded', function () {
  const CUSTOM_PRODUCT_HANDLE = 'custom-charge-unit';
  const FALLBACK_VARIANT_IDS = ["55795499139459", "56535863787907"]; // Glass + Brick price-unit IDs
  const CALCULATOR_VARIANT_ID = "55795499139459"; // Prevent ReferenceError
  const isCalculatorItem = (item) => item && (
    (typeof CALCULATOR_VARIANT_ID !== 'undefined' && item.variant_id && item.variant_id.toString() === CALCULATOR_VARIANT_ID) ||
    (item.variant_id && FALLBACK_VARIANT_IDS.includes(item.variant_id.toString())) ||
    item.product_handle === CUSTOM_PRODUCT_HANDLE ||
    (item.properties && (item.properties['_Product Title'] === 'Custom Cut Stove Glass' || item.properties['_Product Title'] === 'Custom Cut Brick'))
  );

  const buildCalculatorKey = (properties) => {
    const propertyKeys = Object.keys(properties || {}).filter(key => key !== 'Quantity' && !key.startsWith('_'));
    return propertyKeys.map(key => `${key}:${properties[key]}`).sort().join('|') || 'no-properties';
  };

  function improveCartQuantityDisplay() {
    // DISABLED (Oct 2026 audit): its selector DOES match the live cart table
    // (class="data-table full cart-table"), so it ran on every cart page load.
    // It rewrote each stepper input to the order-time _Quantity and then set
    // readonly + pointer-events:none - which reverted customer qty edits and
    // re-locked pool rows, undoing the deliberate pool unlock. It also appended
    // a competing "Quantity from calculator" note on pool rows.
    // Server-rendered Liquid (sections/cart-template.liquid) now owns quantity
    // display: penny lines are locked with a note, pool lines have real
    // steppers, split/offer rows are locked with their own note.
    return;
    let splitQuantityCorrections = 0;

    // Use throttled cart from simplePool if available, otherwise fallback to direct fetch
    const getCart = (typeof simplePool !== 'undefined' && simplePool.getThrottledCart)
      ? simplePool.getThrottledCart.bind(simplePool)
      : () => fetch('/cart.js').then(res => res.json());

    getCart()
      .then(cart => {
        // Target the specific cart table structure
        const cartTable = document.querySelector('table.data-table.full.cart-table');
        if (!cartTable) {
          console.log("Cart table not found");
          return false;
        }

        const cartRows = cartTable.querySelectorAll('tbody tr');
        let foundCustomItems = false;

        // Create a map of line items by key/ID for quick lookup
        const cartItemsMap = {};
        cart.items.forEach(item => {
          cartItemsMap[item.key] = item;
        });

        // Count calculator items by "calculator key" to detect split lines (e.g. discounts)
        const calculatorKeyCounts = {};
        cart.items.forEach(item => {
          if (isCalculatorItem(item)) {
            const key = buildCalculatorKey(item.properties);
            calculatorKeyCounts[key] = (calculatorKeyCounts[key] || 0) + 1;
          }
        });

        cartRows.forEach(row => {
          // Check if this row contains our custom charge unit
          const productLink = row.querySelector(`a[href*="/products/${CUSTOM_PRODUCT_HANDLE}"]`);
          const productNameEl = row.querySelector('h5.product-name');

          if (productLink || (productNameEl && productNameEl.textContent.includes('Custom Charge Unit'))) {
            foundCustomItems = true;
            console.log("Found custom charge unit row:", row);

            // Get the line item key from the row
            const qtyInput = row.querySelector('input[id^="updates_"]');
            let lineItemKey = null;
            let cartItem = null;

            if (qtyInput) {
              // Extract the line item key from the input name (format: updates[key])
              const inputName = qtyInput.name;
              const keyMatch = inputName.match(/updates\[(.*?)\]/);
              if (keyMatch && keyMatch[1]) {
                lineItemKey = keyMatch[1];
                cartItem = cartItemsMap[lineItemKey];
              }
            }

            // Extract properties from cart_meta-text div
            const metaTextDiv = row.querySelector('div.cart__meta-text');
            let actualQuantity = 1; // Default to 1

            // First try to get quantity from the cart item properties
            if (cartItem && cartItem.properties && (cartItem.properties.Quantity || cartItem.properties._Quantity)) {
              actualQuantity = parseInt(cartItem.properties.Quantity || cartItem.properties._Quantity);
              console.log("Found actual quantity in cart item properties:", actualQuantity);
            }
            // If not found in cart item, try to extract from the displayed properties
            else if (metaTextDiv) {
              const quantityMatch = metaTextDiv.innerHTML.match(/Quantity:\s*([0-9]+)/i);
              if (quantityMatch) {
                actualQuantity = parseInt(quantityMatch[1]);
                console.log("Found actual quantity in displayed properties:", actualQuantity);
              }
            }

            // If Shopify split the same calculator item into multiple lines (e.g. discounts),
            // show the line item quantity instead of repeating the calculator quantity.
            if (cartItem && cartItem.properties) {
              const calcKey = buildCalculatorKey(cartItem.properties);
              if (calculatorKeyCounts[calcKey] > 1) {
                splitQuantityCorrections++;
                actualQuantity = parseInt(cartItem.quantity) || actualQuantity;
              }
            }

            // Final fallback to cart item quantity when available
            if (cartItem && (!actualQuantity || isNaN(actualQuantity))) {
              actualQuantity = parseInt(cartItem.quantity) || 1;
            }

            console.log("Using actual quantity for display:", actualQuantity);

            // Update the quantity display in the Qty column
            const qtyCell = row.querySelector('td[data-label="Qty"], td.product-qty');
            if (qtyCell) {
              // Find the quantity input
              const qtyInput = qtyCell.querySelector('input[id^="updates_"]');
              if (qtyInput) {
                // Update the displayed quantity to match the actual quantity from properties
                if (qtyInput.value !== actualQuantity.toString()) {
                  qtyInput.value = actualQuantity.toString();
                }

                // Make the visible input read-only to prevent confusion
                if (!qtyInput.hasAttribute('readonly')) {
                  qtyInput.setAttribute('readonly', 'readonly');
                  qtyInput.style.pointerEvents = 'none';
                }

                // Disable the +/- buttons
                const minusButton = qtyCell.querySelector('.reduced.items');
                const plusButton = qtyCell.querySelector('.increase.items');

                if (minusButton && minusButton.style.pointerEvents !== 'none') {
                  minusButton.style.pointerEvents = 'none';
                  minusButton.style.opacity = '0.5';
                }

                if (plusButton && plusButton.style.pointerEvents !== 'none') {
                  plusButton.style.pointerEvents = 'none';
                  plusButton.style.opacity = '0.5';
                }

                // Add a note explaining why the quantity can't be changed here
                if (!qtyCell.querySelector('.calculator-qty-note')) {
                  const qtyNote = document.createElement('div');
                  qtyNote.className = 'calculator-qty-note';
                  qtyNote.style.cssText = 'font-size: 10px; color: #777; margin-top: 5px;';
                  qtyNote.textContent = 'Quantity from calculator';
                  qtyCell.appendChild(qtyNote);
                }
              } else {
                // If we can't find the input, create a simple display
                const displayValue = actualQuantity.toString();
                if (qtyCell.textContent !== displayValue) {
                  qtyCell.innerHTML = '';
                  const qtyDisplay = document.createElement('div');
                  qtyDisplay.textContent = displayValue;
                  qtyDisplay.style.cssText = 'font-weight: bold; font-size: 16px; text-align: center; color: #333;';
                  qtyCell.appendChild(qtyDisplay);
                }
              }

              // Mark this cell as processed with the actual quantity
              if (qtyCell.getAttribute('data-qty-fixed') !== actualQuantity.toString()) {
                qtyCell.setAttribute('data-qty-fixed', actualQuantity.toString());
                qtyCell.setAttribute('data-qty-processed', 'true');
              }
            }

            // Also update the item title to show the quantity
            const titleElement = row.querySelector('h5.product-name');
            if (titleElement && actualQuantity > 1) {
              const qtyIndicator = `(Qty: ${actualQuantity})`;
              if (!titleElement.textContent.includes(qtyIndicator)) {
                let titleText = titleElement.textContent.replace(/\s*\(Qty: \d+\)/, '');
                titleElement.textContent = `${titleText} ${qtyIndicator}`;
              }
            }
          }
        });

        if (splitQuantityCorrections > 0) {
          try {
            const storageKey = 'calculator_monitoring_metrics';
            const current = JSON.parse(localStorage.getItem(storageKey) || '{}');
            current.cart_split_quantity_corrections = (current.cart_split_quantity_corrections || 0) + splitQuantityCorrections;
            current.lastUpdated = Date.now();
            localStorage.setItem(storageKey, JSON.stringify(current));

            document.dispatchEvent(new CustomEvent('calculator:monitoring', {
              detail: {
                metric: 'cart_split_quantity_corrections',
                count: current.cart_split_quantity_corrections,
                lastBatch: splitQuantityCorrections,
                timestamp: current.lastUpdated
              }
            }));
          } catch (e) {
            console.log('Monitoring metric write failed:', e);
          }
        }

        return foundCustomItems;
      })
      .catch(error => {
        console.error("Error fetching cart for quantity display:", error);
        return false;
      });
  }

  // Flag to prevent recursive combinations
  let isCombining = false;

  // Helper function to combine identical calculator items
  function combineIdenticalCalculatorItems() {
    // DISABLED (Oct 2026 audit): auto-merging undercharges. Pool lines are
    // intentionally separate variants - keeping the first line's quantity while
    // summing _Quantity halves the total (2 x £52.51 -> 1 x £52.51). Penny
    // lines carry price in quantity (3296 x £0.01) with the same result. It also
    // orphans pool variants at custom prices (removed line's variant is never
    // reset by the order webhook). Penny fallback already merges identical items
    // at add time. Display-only fixes below are unaffected.
    return;
    if (isCombining) return;
    isCombining = true;

    console.log("Checking for identical calculator items to combine...");

    // Use throttled cart from simplePool if available, otherwise fallback to direct fetch
    const getCart = (typeof simplePool !== 'undefined' && simplePool.getThrottledCart)
      ? simplePool.getThrottledCart.bind(simplePool)
      : () => fetch('/cart.js').then(res => res.json());

    getCart()
      .then(cart => {
        // Group calculator items by their properties
        const calculatorItems = {};
        const updatedItems = [];
        let needsUpdate = false;

        let hasLineDiscounts = false;

        cart.items.forEach(item => {
          if (isCalculatorItem(item)) {
            if ((item.line_level_discount_allocations && item.line_level_discount_allocations.length) ||
                (typeof item.final_line_price !== 'undefined' && typeof item.original_line_price !== 'undefined' && item.final_line_price !== item.original_line_price)) {
              hasLineDiscounts = true;
            }

            // Create a key from the item's properties (excluding Quantity and internal ones)
            const propertyKey = buildCalculatorKey(item.properties);

            if (!calculatorItems[propertyKey]) {
              calculatorItems[propertyKey] = {
                quantity: parseInt(item.properties.Quantity || item.properties._Quantity || item.quantity || 1),
                originalQuantity: item.quantity,
                properties: item.properties,
                itemKey: item.key
              };
            } else {
              // Found a duplicate! Add its quantity to the first one
              const newQuantity = calculatorItems[propertyKey].quantity + parseInt(item.properties.Quantity || item.properties._Quantity || item.quantity || 1);
              calculatorItems[propertyKey].quantity = newQuantity;

              // Mark this item for removal (quantity = 0)
              updatedItems.push({ id: item.key, quantity: 0 });
              needsUpdate = true;
            }
          } else {
            // Not a calculator item, include normally in updates list
            updatedItems.push({ id: item.key, quantity: item.quantity });
          }
        });

        if (hasLineDiscounts) {
          console.log("Detected line-item discounts on calculator items, skipping auto-combine to avoid breaking discounts.");
          needsUpdate = false;
        }

        // If we found duplicates, update the cart
        if (needsUpdate) {
          console.log("Found duplicate calculator items, combining them...");

          // Add the combined calculator items back to the update list
          Object.values(calculatorItems).forEach(item => {
            const properties = { ...item.properties, _Quantity: item.quantity.toString() };
            updatedItems.push({
              id: item.itemKey,
              quantity: item.originalQuantity,
              properties: properties
            });
          });

          // Update the cart
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updatedItems })
          })
            .then(response => response.json())
            .then(updatedCart => {
              console.log("Cart updated with combined calculator items");
              updateCartDisplay(updatedCart);
            });
        }
      })
      .catch(error => console.error("Error in combineIdenticalCalculatorItems:", error))
      .finally(() => {
        // Reset flag after a delay to ensure everything settled
        setTimeout(() => { isCombining = false; }, 1000);
      });
  }

  // Function to manually update the cart display without reloading
  function updateCartDisplay(cart) {
    console.log("Manually updating cart display");

    // First update all quantity displays
    const miniCartQuantities = document.querySelectorAll('.mini-cart .cart-qty, .header-cart .cart-qty, .cart-count, .mini-cart-count, [class*="cart-count"], [class*="cart-qty"]');

    // Calculate real item count. Same-variant split lines (discount splits)
    // each carry the order-wide _Quantity: count the human total once per
    // variant group (see mini-cart-quantity-fix).
    const variantGroups = {};
    cart.items.forEach(item => {
      const k = String(item.variant_id);
      (variantGroups[k] = variantGroups[k] || []).push(item);
    });
    let realItemCount = 0;
    cart.items.forEach(item => {
      if (typeof CALCULATOR_VARIANT_ID !== 'undefined' && (item.variant_id.toString() === CALCULATOR_VARIANT_ID ||
        FALLBACK_VARIANT_IDS.includes(item.variant_id.toString()) ||
        item.product_handle === CUSTOM_PRODUCT_HANDLE ||
        (item.properties && item.properties['_Product Title']))) {
        const group = variantGroups[String(item.variant_id)] || [item];
        if (group.length > 1) {
          if (group[0] === item) {
            const hTotal = parseInt(group[0].properties.Quantity || group[0].properties._Quantity || 0, 10);
            realItemCount += hTotal > 0 ? hTotal : group.reduce((s, it) => s + (parseInt(it.quantity, 10) || 0), 0);
          }
        } else {
          realItemCount += parseInt(item.properties.Quantity || item.properties._Quantity || item.quantity || 1);
        }
      } else {
        realItemCount += item.quantity;
      }
    });

    // Update all quantity displays
    miniCartQuantities.forEach(qtyElement => {
      qtyElement.textContent = realItemCount;
    });

    // Update cart total displays
    const cartTotals = document.querySelectorAll('.cart-total-items, .total-items');
    cartTotals.forEach(total => {
      if (total.textContent.includes('item')) {
        total.textContent = `${realItemCount} item${realItemCount !== 1 ? 's' : ''}`;
      }
    });

    // Now run our quantity display improvement function
    setTimeout(improveCartQuantityDisplay, 100);

    // Trigger a custom event that other scripts might be listening for
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  // Run our functions with proper timing
  // First combine identical items
  setTimeout(combineIdenticalCalculatorItems, 300);
  // Then improve quantity display after a delay
  setTimeout(improveCartQuantityDisplay, 800);

  // Also run when cart is updated
  document.addEventListener('cart:updated', () => {
    // First combine identical items
    setTimeout(combineIdenticalCalculatorItems, 200);
    // Then improve quantity display after a delay
    setTimeout(improveCartQuantityDisplay, 500);
  });

  // Watch for DOM changes in the cart
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.target.closest('.cart-table, #cart, .cart-form')) {
        setTimeout(improveCartQuantityDisplay, 100);
      }
    });
  });

  // Start observing
  const cartContainer = document.querySelector('.cart-table, #cart, .cart-form');
  if (cartContainer) {
    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }
});
